<template>
    <div class="flex w-full" style="padding-top: 1.5rem; padding-bottom: 1.5rem;justify-content: start; text-align: left;padding: 28px; background: #f5f7f9;">    
        <div > 
            <div  v-if="script.customJS" style="padding-bottom: 1.5rem;" >
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">JavaScript:</div>
                <div id="js-script" class="flex w-full editor-parent editor-div">
                    <textarea id="js-section" rows="10" readonly v-model="script.customJS" class="editor my-1" >
                    </textarea>
                    <button style="background: none" class="custom-button expand-button" @click="expand(true,script.customJS,'JavaScript')"><i class="fa fa-expand icon"  /></button>
                </div>
            </div> 
             <div  v-if="script.customCSS" style="padding-bottom: 1.5rem;" >
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">CSS:</div>
                <div id="css-script" class="flex w-full editor-parent editor-div">
                    <textarea id="css-section" rows="10" readonly v-model="script.customCSS" class="editor my-1" >
                    </textarea>
                    <button style="background: none" class="custom-button expand-button" @click="expand(true,script.customCSS,'Custom CSS')"><i class="fa fa-expand icon" /></button>
                </div>
            </div>
            <div v-if="script.securityConcerns && script.securityConcerns.length">
                <div style="display: inline;padding-bottom: 0.5rem;" class="heading-font">Security Issues found:</div>
                <div  style="display: flex; gap: 0.5rem;flex-wrap: wrap; ">
                    <div  v-for="(concern, index) in script.securityConcerns" class="tag danger p-1">{{ concern }}</div>
                </div>
            </div>
        </div>

        <CodeModal  :showModal="isExpanded" :data="code" @close="expand" :header="type"/>
    </div>
</template>
  
<script>
import CodeModal from "@/components/marketplace/marketplaceAppsReviewPortal/customJsReviewPortal/CodeModal"

export default {
    components:{CodeModal},
    props:{
        data: Object
    },
    data(){
        return {
            isExpanded:false,
            code :"",
            type:""
        }
    },
    computed: {
        script: {
            get() {
                return this.data
            }
        }
    },
    methods: {
      formatTime(time){
        return moment(time).format(
          "MMM DD, YYYY"
        )
      },  
      expand(value=false, code="", type=""){
        this.isExpanded = value
        this.code = code
        this.type = type
      }
    }
  };

</script>
<style>
.editor {
    background: #ffffff;
    font-family: Roboto, system, -apple-system, BlinkMacSystemFont, '.SFNSDisplay-Regular', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 0.875rem;
    color: #2a3135;
    border: none;
    border-radius: 0.3125rem;
    padding: 15px 20px;
    transition: all 0.2s ease-in-out 0s;
    width: 100%;
 
}
.editor-div{
    display: flex;
    position: relative;
}

.expand-button{
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.custom-button{
    color: black;
    padding: 0;
}
</style>